

exports.__esModule = true;

var _index = require('squid/index');

var _index2 = require('xo-models/src/user/index');

var _index3 = require('xo-models/src/checkout/index');

var _index4 = require('xo-models/src/profilemanagement/index');

var _logger = require('xo-beaver/dist/logger');

var _uiRouter = require('uiRouter');

var _index5 = require('xo-device-info/dist/index');

var _contentKeys = require('../../lib/contentKeys');

var _pxpExperimentConstants = require('../constants/pxpExperimentConstants');

var _pxpExperimentConstants2 = _interopRequireDefault(_pxpExperimentConstants);

require('./guest/directive.js');

require('./signup/directive.js');

require('xo-page-components/src/marketingOffers/directive.js');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoOnboardOptions', {
    tag: 'xo-onboard-options',
    template: _template2['default'],

    props: {
        token: {
            type: 'var'
        },
        flags: {
            type: 'var'
        },
        mode: {
            type: 'var'
        },
        onboard: {
            type: 'var'
        },
        singlePagePaymentForm: {
            type: 'var'
        },
        validated: {
            type: 'var'
        },
        sepa: {
            type: 'var'
        },
        merchant: {
            type: 'var'
        },
        isUnbranded: {
            type: 'var'
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutInputData: _index2.$CheckoutInputDataModel.instance(this.token).retrieve(),
                payee: _index3.$CheckoutPayeeModel.instance(this.token).retrieve(),
                checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.token).retrieve(),
                checkoutCart: _index3.$CheckoutCartModel.instance(this.token).retrieve(),
                flowEligibility: _index3.$FlowEligibilityModel.instance(this.token).retrieve()
            };
        },
        pomaExperiment: function pomaExperiment() {
            if (this.mode === 'guest') {
                return {
                    poma: (0, _index.$pxp)('XO_XOONBOARDING_POMA_GLOBAL', { 'ctx.COUNTRY': _index.$locale.country }, '(XO_XOONBOARDING_POMA_GLOBAL_)(.*)')
                };
            }
        },
        experiments: function experiments() {
            var experiment = 'xo_xoonboarding_dcc_';
            var pilotCountries = ['US', 'GB', 'CA', 'AU'];

            if (pilotCountries.indexOf(_index.$locale.country) > -1) {
                experiment += 'pilot';
            } else if (_index.$config.regions.EMEA.indexOf(_index.$locale.country) > -1) {
                experiment += 'emea';
            } else {
                experiment += 'row';
            }
            return {
                optionalSignupContent: (0, _index.$pxp)('xoon_optional_signup_content_change', { 'ctx.COUNTRY': _index.$locale.country }, '(xoon_optional_signup_content_change_)(.*)'),
                wpsInterstitial: (0, _index.$pxp)('XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP', { 'ctx.COUNTRY': _index.$locale.country }, 'XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP.*'),
                dccEligibility: (0, _index.$pxp)(experiment, { 'ctx.COUNTRY': _index.$locale.country }, experiment + '_treatment')
            };
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _index.$locale;
        },
        populate: function populate() {
            var _this = this;

            this.models.merchantPreference = _index4.$MerchantPreferenceModel.instance(this.models.payee.merchant.id);
            this.isRP = this.models.checkoutCart.billing && this.models.checkoutCart.billing.type === 'RECURRING_PAYMENTS';
            this.showBAContent = this.models.checkoutCart.isBilling() && !this.models.checkoutCart.isWalletTokenization();
            this.contentKeys = {};

            var setUnbrandedContent = function setUnbrandedContent() {

                _this.onboardTitleLine1 = _this.isUnbranded ? 'common.getBenefitsUnBrandedLine1' : 'common.getBenefitsLine1';
                _this.subTitle = _this.isUnbranded ? 'common.createPayPalUnBrandedProp' : 'common.createPayPalProp';
                _this.paypalSubTitle = _this.isUnbranded ? 'common.createPayPalUnBrandedSubTitle' : 'common.createPayPalSubTitle';
                _this.guestSignup1 = _this.isUnbranded ? 'common.yesCreateUnBrandedAccount' : 'common.yesCreateAccount';
                _this.guestSignup2 = _this.isUnbranded ? 'common.nothanksUnBranded' : 'common.nothanks';
            };

            setUnbrandedContent();

            var contentOpts = {
                $config: _index.$config,
                cart: this.models.checkoutCart,
                appData: this.models.checkoutAppData
            };
            this.baContentKey = (0, _contentKeys.getBAContentKey)(contentOpts);
            this.rpContentKey = (0, _contentKeys.getRPContentKey)(contentOpts);
            this.wpsFlow = this.models.checkoutAppData.doec_on_approve();

            var setDCCEligibilityFlag = function setDCCEligibilityFlag(mode) {

                if (mode === 'signup') {
                    return;
                }

                var experiment = _this.experiments.dccEligibility;
                _this.flags.dccCountryEligibility = experiment && experiment.treatment_name;
            };

            /**
             * show WPS interstitial page, if
             * 1. its optional sign up flow and
             * 2. not multistep flow and not DE
             * 3. merchant pref not have pdt or auto return and
             * 4. one touch throttle is not control
             * 5. wps interstitial throttle return treatment experiment
             **/
            var checkWPSInterstitialEligibility = function checkWPSInterstitialEligibility(mode) {
                if (!_this.wpsFlow) {
                    return;
                }
                if (_this.mode === 'signup') {
                    _logger.$logger.info('wps_interstitial_not_eligible_force_signup');
                    return;
                }
                if (_this.models.merchantPreference) {
                    if (_this.models.merchantPreference.autoReturn()) {
                        _logger.$logger.info('wps_interstitial_not_eligible_merchant_prefer_auto_return');
                        return;
                    }
                    if (_this.models.merchantPreference.pdtEnabled()) {
                        _logger.$logger.info('wps_interstitial_not_eligible_merchant_prefer_pdt_enabled');
                        return;
                    }
                }

                /*
                 * pxp XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP will test 3 variants:
                 * 1. XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP_control - wps interstitial with guest only experience
                 * 2. XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP_treatment1 - optional guest without wps interstitial
                 * 3. XO_XOONBOARDING_WPS_INTERSTITIAL_OPTIONAL_SIGNUP_treatment2 - wps interstitial with optional signup
                 */
                var wpsPXP = _this.experiments.wpsInterstitial;
                var treatment = wpsPXP && _pxpExperimentConstants2['default'].test['xoon_wps_interstitial_optional_signup'][wpsPXP.treatment_name];
                if (treatment) {
                    _logger.$logger.info('wps_interstitial_pxp_' + wpsPXP.treatment_name);
                    _this.flags.wpsInterstitialEligible = treatment['interstitialEligible'];
                    _this.flags.buyerMode = treatment['buyerMode'];
                    _this.mode = treatment['mode'];
                }
            };

            var setEcPomaFlag = function setEcPomaFlag() {
                var pomaPXP = _this.pomaExperiment.poma;
                if (pomaPXP && pomaPXP.treatment_name.indexOf('XO_XOONBOARDING_POMA_GLOBAL_TREATMENT') > -1) {
                    _logger.$logger.info('checkout_fpti', { is_poma: 1 });
                    _this.flags.wpsInterstitialEligible = false;
                    _this.flags.show_poma_ui = true;
                    _this.POMAContentType = pomaPXP.treatment_name.indexOf('TREATMENT_A') > -1 ? 'TREATMENT_A' : 'TREATMENT_B';
                }
            };

            var setOptionalSignupPromotionContent = function setOptionalSignupPromotionContent(mode) {
                if (mode !== 'guest') {
                    return;
                }

                var optionSignupContentPXP = _this.experiments.optionalSignupContent;
                if (optionSignupContentPXP && optionSignupContentPXP.treatment_name) {
                    var treatmentContentKeys = _pxpExperimentConstants2['default'].test['xoon_optional_signup_content_change'][optionSignupContentPXP.treatment_name];

                    _this.contentKeys = treatmentContentKeys ? treatmentContentKeys : {};
                }
            };

            var setFlagsPostFlowEligibility = function setFlagsPostFlowEligibility(mode) {
                var trackingModes = ['guest', 'guestonly'];
                _this.flags.track_submit_transition = trackingModes.indexOf(_this.mode) > -1 ? 'guest_xo' : 'signup';

                checkWPSInterstitialEligibility(mode);
                setDCCEligibilityFlag(mode);
                setOptionalSignupPromotionContent(mode);

                // POMA - Passwordless Onboarding of Member Accounts
                if (mode === 'guest' && _index.$locale.country === 'US' && !_index5.$DeviceInfo.isWebView()) {
                    if (!_this.wpsFlow) {
                        setEcPomaFlag();
                    }
                }

                _this.flags.mode = _this.mode;
                _this.flags.signupEnabled = _this.mode !== 'guestonly';
                _this.flags.allowChoice = _this.mode !== 'signup';

                // Initialize showDisabledPasswordField to true.
                // NOTE: We use the if condition to check for undefined so the variable is assigned only once.
                // This method is called on every locale change, so we don't want it to be true on every change.
                // In future cases, signupSelected and guestSelected will set it accordingly.
                if (_this.flags.showDisabledPasswordField === undefined) {
                    _this.flags.showDisabledPasswordField = true;
                }
            };
            setFlagsPostFlowEligibility(this.mode);
        }
    },
    actions: {
        setBuyerModeFlags: function setBuyerModeFlags(newValue) {
            switch (newValue) {
                case 'guest':
                case 'guestonly':
                    // show disabled password field for variant2
                    this.flags.showDisabledPasswordField = true;
                    this.flags.showEmailBelowName = true;
                    _logger.$logger.info('Guest_Signup_No');
                    this.flags.mode = newValue;
                    this.flags.track_submit_transition = 'guest_xo';
                    break;
                case 'signup':
                    // hide disabled password field
                    this.flags.showEmailBelowName = false;
                    this.flags.showDisabledPasswordField = false;
                    this.flags.ignoreValidationTheFirstTime = true;
                    _logger.$logger.info('Guest_Signup_Yes');
                    this.flags.mode = newValue;
                    this.flags.track_submit_transition = 'guest_optional_signup';
                    break;
                default:
                // Do Nothing
            }
            this.accountCreationSectionErrorMessage = '';
            $('.signupFieldsContainer .radioButton').removeClass('warning');
            _uiRouter.$state.current.trackingData.pageQualifier = newValue;
            return true;
        },
        triggerTimerForSignupClicked: function triggerTimerForSignupClicked() {
            if (window.performance) {
                _logger.$logger.info('sign up option clicked, start timer...', window.performance.now());
                this.$emit('signupClickedTimerStarted', window.performance.now());
            }
        },
        onCheckedSavedMyInfo: function onCheckedSavedMyInfo($event) {
            if ($event.target.checked) {
                // populating the legal terms key to send the TCPA details to OAS later during onboarding
                this.flags.tcpa_identifier = 'poma.legalTerms';
                this.flags.poma_flow = true;
                this.flags.track_submit_transition = 'poma_signup';
                $('.pomaFieldsContainer').addClass('focusBorder');
                $('.pomaFieldsContainer').addClass('active');
                _logger.$logger.info('POMA_CHECKBOX_SELECTED');
                if ($('#pomaSubmit').offset()) {
                    window.scrollTo(0, this.$element.parent().find('#pomaSubmit').offset().top);
                }
            } else {
                this.flags.tcpa_identifier = undefined;
                this.flags.poma_flow = false;
                this.flags.track_submit_transition = 'guest_xo';
                $('.pomaFieldsContainer').removeClass('focusBorder');
                $('.pomaFieldsContainer').removeClass('active');
                _logger.$logger.info('POMA_CHECKBOX_DESELECTED');
            }
        }
    }
});


_index.$Component;

_index.$locale;

_index.$pxp;

_index.$config;

_index2.$CheckoutInputDataModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutPayeeModel;

_index3.$CheckoutCartModel;

_index3.$FlowEligibilityModel;

_index4.$MerchantPreferenceModel;

_logger.$logger;

_uiRouter.$state;

_index5.$DeviceInfo;

_contentKeys.getBAContentKey;

_contentKeys.getRPContentKey;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/onboardOptions/directive.js
// module id = ./components/xo-guest-components/src/guest/onboardOptions/directive.js
// module chunks = 1